import { getAmplitudeInstance } from '../amplitudeHelpers';
import CarouselDisplayTrigger from '../enums/CarouselDisplayTrigger';
import ProductsAvailable from '../enums/ProductsAvailable';
import PurchaseScreenTypePlan from '../enums/PurchaseScreenTypePlan';

type logProPurchasePageViewedParams = {
  pro_landing_page_experiment_variant_name?: string;
  products_available?: ProductsAvailable;
  purchase_screen_type_plan: PurchaseScreenTypePlan;
  trigger?: CarouselDisplayTrigger;
};

/**
 * User visits alltrails.com/pro page.
 * @param params - Attributes to log with the amplitude event
 * @param params.pro_landing_page_experiment_variant_name - The name of the variant that is being shown to the user - specific for Optimizely experiment ID: 21475990068.
 * @param params.products_available - The combination of available products offered on an upsell (plus, plus-peak, peak).
 * @param params.purchase_screen_type_plan - The plan shown on the pro purchasing event occurs on (e.g. trial, non-trial, promo, etc.)
 * @param params.trigger - The trigger that caused the web pro modal to display.
 */
const logProPurchasePageViewed = (
  { pro_landing_page_experiment_variant_name, products_available, purchase_screen_type_plan, trigger }: logProPurchasePageViewedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'pro purchase page viewed',
    {
      'pro landing page experiment variant name': pro_landing_page_experiment_variant_name,
      'products available': products_available,
      'purchase screen type plan': purchase_screen_type_plan,
      trigger
    },
    callback
  );
};

export default logProPurchasePageViewed;
